import { useContext } from 'react'

// context
import { AppContext } from '../../App'

// components
import Button from '../button/button'

// styles
import styles from './step-card-nav.module.scss'

const StepCardNav = (): JSX.Element => {
	const appContext = useContext(AppContext)

	const currentStep = appContext?.currentStep || 1

	const goToStep = (index: number) => {
		let nextIndex = index
		if (nextIndex < 1) nextIndex = 1

		if (appContext?.setCurrentStep) appContext.setCurrentStep(nextIndex)
	}

	const previousButtonClick = () => {
		goToStep(currentStep - 1)
	}

	const nextButtonClick = () => {
		goToStep(currentStep + 1)
	}

	return (
		<div className={styles.stepCardNav}>
			<span>
				{currentStep > 1 && (
					<Button
						type="button"
						theme="secondary"
						label="Back"
						onClick={previousButtonClick}
					/>
				)}
			</span>
			<span>
				{currentStep === 1 && (
					<Button
						type="button"
						theme="primary"
						label="Next"
						disabled={
							!appContext?.uploadedImage ||
							!appContext.claimNumber
								? true
								: undefined
						}
						onClick={nextButtonClick}
					/>
				)}
				{currentStep === 2 && (
					<Button
						type="button"
						theme="primary"
						label="Next"
						onClick={nextButtonClick}
					/>
				)}
				{currentStep === 3 && (
					<Button
						type="button"
						theme="primary"
						label="View Next Best Action"
						onClick={nextButtonClick}
					/>
				)}
				{currentStep === 4 && (
					<Button
						type="button"
						theme="primary"
						label="Confirm"
						disabled
					/>
				)}
			</span>
		</div>
	)
}

export default StepCardNav
